import { css } from "@emotion/react";

export const phoneInput = css`
  width: 100%;
`;
